import { render, staticRenderFns } from "./ClientExpand.vue?vue&type=template&id=3968f605&scoped=true&"
import script from "./ClientExpand.vue?vue&type=script&lang=js&"
export * from "./ClientExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968f605",
  null
  
)

export default component.exports